import React, { Component } from "react";
import MaterialAutoComplete from "./MaterialAutoComplete";
import { get } from "lodash";
import fetch from "../../utils/fetch";
import { constructQuery } from "../Grid/dataActions";
import { identity, isArray, isEmpty } from "lodash";

const filter = () => true; // we use backend filtering

export class AutoComplete extends Component {
  static defaultProps = {
    dataSource: [],
    updateFields: [],
    filter, // MaterialAutoComplete.caseInsensitiveFilter,
    applyFilter: identity,
    minLength: 0,
    debounceMs: 350,
    dataSourceConfig: {
      value: "id",
      text: "name",
    },
    filters: [],
  };

  state = {
    dataSource: [],
    isLoading: false,
  };

  _selecting = false;
  _selectedValue = null;
  _debounceTimer = null;
  _abortController = null;
  _requestSeq = 0;

  async componentDidMount() {
    const { reload, searchText, dataSourceConfig, dispatch } = this.props;
    if (reload && searchText) {
      const searchToken = searchText.split("-")[0].trim();
      const items = await this.updateDataSource(searchToken);
      const item = items.find(i => i[dataSourceConfig.text] === this.props.searchText);
      if(item) {
        this.handleNewRequest(item);
      }
    }
  }

  updateDataSource = async (query) => {
    const {
      url,
      applyFilter,
      filters,
      noActiveFilter,
      dataSourceConfig,
      searchBy,
      operation,
      dispatch,
    } = this.props;
    const searchField = searchBy ? searchBy : dataSourceConfig.text;
    const searchOperation = operation ? operation : "CONTAINS";

    const activeFilter = noActiveFilter
      ? {}
      : { field: "active", operation: "EQ", value: "true" };
    const queryFilter = query
      ? { field: searchField, operation: searchOperation, value: query }
      : {};

    const constructedQuery = constructQuery({
      filters: [activeFilter, queryFilter, ...filters],
      sort: dataSourceConfig.sortBy ? dataSourceConfig.sortBy : dataSourceConfig.text,
      order: "ASC",
      pageSize: query.length <= 3 ? 30 : 100,
      page: 0,
    });

    if (this._abortController) {
      this._abortController.abort();
    }

    this._abortController = new AbortController();
    const currentRequestSeq = ++this._requestSeq;

    this.setState({ isLoading: true });

    try {
      const response = await fetch(url, dispatch, {
        params: constructedQuery,
        signal: this._abortController.signal,
      });
      const dataSource = await response.json();

      if (currentRequestSeq !== this._requestSeq) {
        return;
      }

      const dataSourceRaw = isArray(dataSource)
        ? dataSource
        : dataSource.items || [];

      let processedData = dataSourceRaw;
      if (dataSourceConfig.textConcat) {
        processedData = dataSourceRaw.map(item => {
          let newItem = { ...item };
          Object.entries(dataSourceConfig.textConcat).forEach(([targetField, fields]) => {
            newItem[targetField] = fields
            .map(f => f === "-" ? "-" : item[f])
            .filter(v => v !== undefined && v !== null)
            .join(" ");
          });
          return newItem;
        });
      }
      const results = applyFilter(processedData);
      this.setState({
        dataSource: results,
      });

      return results;
    } catch (e) {
      if (e && (e.name === "AbortError" || e.code === 20)) {
        return;
      }

      if (currentRequestSeq !== this._requestSeq) {
        return;
      }

      this.setState({ dataSource: [] });
    } finally {
      if (currentRequestSeq === this._requestSeq) {
        this.setState({ isLoading: false });
      }
    }
  };

  handleNewRequest = (chosenRequest, index, event) => {
    const { onChange, onBlur } = this.props;
    const value = isEmpty(chosenRequest) ? null : chosenRequest;
    this._selecting = false;
    onChange(value);
    // Mark field as touched with selected value
    if (onBlur) onBlur(value);  

    if(event && event.type === "keydown") {
      setTimeout(() => {
        this.refs.materialAutoComplete.refs.searchTextField.focus();
      }, 0);
    }
  };

  handleUpdateInput = (search, dataSource, params) => {
    const { minLength, onChange, debounceMs } = this.props;

    // Pri výbere položky z menu hodnotu nastaví handleNewRequest
    if (params && params.source === "touchTap") {
      this._selecting = true;
      return;
    }

    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }

    if (search.length < minLength) {
      this.setState({ dataSource: [], isLoading: false });
      onChange(isEmpty(search) ? null : search);
      return;
    }

    this._debounceTimer = setTimeout(() => {
      this.updateDataSource(search);
      this._debounceTimer = null;
    }, debounceMs);

    onChange(isEmpty(search) ? null : search);
  };

  onFocus = (e) => {
    const { onFocus } = this.props;
    const val = e.target.value;

    if (val.length >= this.props.minLength) {
      this.updateDataSource(val);
    }
    if (onFocus) onFocus();
  };

  onBlur = (e) => {
    const { onChange, onBlur, searchText } = this.props;
    const { dataSource } = this.state;

    // Auto-select if only one result
    if (dataSource.length === 1) {
      onChange(dataSource[0]);
    }

    if (onBlur && typeof searchText === "string" && searchText !== "") onBlur(e);
  };

  componentWillUnmount() {
    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }

    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
  }

  viewVal = (val) => {
    if (typeof val === "object") {
      if (typeof val.get === "function") {
        return val.get(this.props.dataSourceConfig.text);
      }
      return get(val, this.props.dataSourceConfig.text, "");
    }
    return val;
  };

  render() {
    const {
      onChange,
      dataSource,
      url,
      updateFields,
      changeFieldFunc,
      applyFilter,
      searchText,
      textFieldStyle,
      filters,
      searchBy,
      ...rest
    } = this.props; // eslint-disable-line no-unused-vars

    return (
      <MaterialAutoComplete
        onUpdateInput={this.handleUpdateInput}
        searchText={this.viewVal(searchText)}
        onNewRequest={this.handleNewRequest}
        {...this.state}
        {...rest}
        loading={this.state.isLoading}
        openOnFocus={true}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        ref="materialAutoComplete"
      />
    );
  }
}

export default ({
  input: { value, onChange: inputOnChange, onBlur: inputOnBlur, ...irest },
  meta: { touched, error },
  onChange: customOnChange,
  ...rest
}) => {
  const onChange = (val) => {
    inputOnChange(val);
    if (customOnChange) customOnChange(val);
  };
  const onBlur = (val) => {
    inputOnBlur(val);
  };
  return (
    <AutoComplete
      errorText={touched && error}
      searchText={value}
      {...irest}
      {...rest}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};
